










































































































































































































































































































import { AccountManagerService, RoleRoleDTO } from "@/common/api";
import { LANG } from "@/common/constant";
import QErrors from "@/common/qErrors.vue";
import qNotify from "@/common/qNotify";
import LanguageComponent from "@/components/common/languageComponent.vue";
import QUploadSingleImage from "@/components/common/qUploadSingleImage.vue";
import { PropType } from "vue";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  name: "MeEditComponent",
  components: { QErrors, LanguageComponent, QUploadSingleImage },
})
export default class MeEditComponent extends Vue {

  get contentLanguageComputed() {
    if (this.languages[this.contentLanguage] === true) {
      return this.contentLanguage;
    } else {
      return "ja";
    }
  }
  @Prop({
    required: true,
    type: Array as PropType<RoleRoleDTO[]>,
  })
  public roles;

  public isShow = false;
  public errors = {};

  public data = {
    id: null,
    name: "",
    name_en: "",
    name_cn: "",
    email: null,
    kana: null,
    role_id: 1,
    password: null,
    password_confirmation: null,
    image_id: null,
    image: null,
    is_viewable: false,
    comment: null,
    comment_en: null,
    comment_cn: null,
    sort_order: null,
    created_at: null,
  };

  public origin: any = { ...this.data };

  public languages = {
    ja: true,
    en: true,
    cn: true,
  };

  public contentLanguage = LANG.JA;

  public uploading = false;

  public uploadOptions = {
    acceptedFiles: ".jpg, .jpeg, .png",
    maxFilesize: 5, // 5mb
  };

  public show(user) {
    this.errors = {};
    this.detail(user);
    this.isShow = true;
  }

  public confirmCancel() {
    if (JSON.stringify(this.origin) === JSON.stringify(this.data)) {
      this.isShow = false;
    } else {
      this.$modal.showCancel({
        text: this.$t("common.message.cancel_confirm"),
        // we are passing callback method for our confirm button
        onConfirm: () => {
          this.isShow = false;
        },
      });
    }
  }

  public async detail(user) {
    try {
      this.data = {
        id: user.id,
        name: user.name,
        name_en: user.name_en,
        name_cn: user.name_cn,
        email: user.email,
        kana: user.kana,
        role_id: user.role ? user.role.id : null,
        image_id: user.image_id,
        image: user.image,
        is_viewable: user.is_viewable,
        comment: user.comment,
        comment_en: user.comment_en,
        comment_cn: user.comment_cn,
        sort_order: user.sort_order,
        created_at: user.created_at,
        password: null,
        password_confirmation: null,
      };

      this.origin = { ...this.data };
    } catch (error) {
      qNotify.error({
        text: error.body.message,
      });
    }
  }

  public async submit() {
    this.errors = {};
    let result;
    try {
      result = await AccountManagerService.adminAccountEdit(this.data);
    } catch (error) {
      result = error;
    }

    if (result.status == "success") {
      qNotify.success({
        text: this.$t("common.message.updated"),
      });
      this.isShow = false;
      this.$emit("close");
    } else if (result.status == "400") {
      this.errors = result.body.errors;
      if ("comment" in this.errors) {
        this.contentLanguage = LANG.JA;
      } else if ("comment_en" in this.errors) {
        this.contentLanguage = LANG.EN;
      } else if ("comment_cn" in this.errors) {
        this.contentLanguage = LANG.CN;
      }
    } else {
      qNotify.error({
        text: result.body.message,
      });
    }
  }

  public changeFile(file) {
    this.data.image_id = file ? file.id : null;
    this.data.image.id = file ? file.id : null;
    this.data.image.name = file ? file.filePath : null;
  }

  public changeInput(key) {
    this.errors = { ...this.errors, ...{ [key]: [] } };
  }
  public uploadStatus(flag) {
    this.uploading = flag;
  }
}
